export const setStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
}

export const getStorage = (key: string) => {
  return localStorage.getItem(key);
}

export const clearStorage = (key: string): void => {
  localStorage.removeItem(key);
  localStorage.clear();
}

export const setUserStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
}

export const getUserStorage = (key: string) => {
  return localStorage.getItem(key);
}